import Footer from './organisms/Footer/Footer'
import TopNav from './organisms/TopNav/TopNav'
import React, { Component } from 'react'
import HydrationSplitter from './HydrationSplitter'
import { ThemeProvider } from 'styled-components'
import sendWebVitalsToGoogleAnalytics from '../lib/webVitals'
import Head from 'react-helmet'
import getUserGeo from '../lib/getUserGeo'
import isLocationUnitedKingdom from '../domain/location/useCases/isLocationUnitedKingdom'
import trackPageView from '../domain/segment/trackPageView'
import { initTracking } from '../hooks/segment/useSegment'
import { getDepartmentFooter } from '../domain/department'

const theme = {
  white: '#fff',
  black: '#000000',
  charcoal: '#484848',
  darkGray: '#383838',
  lightGray: '#F7F7F7',
  gray: '#e4e4e4',
  medGray: '#A7A7A7',
  test: '#383838',
  orange: '#E55925',
  tan: '#CBBAAE',
  blue: '#7FA0AC',
  purple: '#222263'
}

export default class App extends Component {
  constructor(props) {
    super(props)

    getUserGeo()

    const { breadcrumbs = [] } = this.props

    this.isUnitedKingdomPage = breadcrumbs
      .concat([this.props.title, this.props.facetLocation])
      .some(isLocationUnitedKingdom)
  }

  componentDidMount() {
    const { location, center, pageType, term } = this.props

    initTracking()
    trackPageView({ location, center, pageType, term })

    sendWebVitalsToGoogleAnalytics()
  }

  getDepartmentFooter() {
    const { department, departments } = this.props
    return getDepartmentFooter({ department, departments })
  }

  render() {
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { parentProps: this.props })
        }
        return child
      }
    )
    return (
      <HydrationSplitter>
        <ThemeProvider theme={theme}>
          <Head>
            {/* Enable the Origin Trial for Long Animation Frames API: https://developer.chrome.com/origintrials/#/view_trial/3935020174414970881.
    This helps DebugBear to collect better data to debug INP. The website was registered for the trial by ivan@3perf.com. */}
            <meta
              httpEquiv="origin-trial"
              content="Agy6XzwtTPAw9LHGzLhzpNqx+0X9GjF2iOuxHvt6eHxYbQs48dbvfBULytwdfpT9W4sGI2wP2/naqQX5wMUgOwcAAABeeyJvcmlnaW4iOiJodHRwczovL3JlY292ZXJ5LmNvbTo0NDMiLCJmZWF0dXJlIjoiTG9uZ0FuaW1hdGlvbkZyYW1lVGltaW5nIiwiZXhwaXJ5IjoxNzE2OTQwNzk5fQ=="
            />
          </Head>
          <div>
            <React.Fragment>
              {!this.props.data && (
                <React.Fragment>
                  {!this.props.home && (
                    <TopNav
                      home={this.props.home}
                      pageType={this.props.pageType}
                      title={this.props.title}
                      isBlog={this.props.isBlog}
                      breadcrumbs={this.props.breadcrumbs}
                      showBreadCrumbs={this.props.showBreadCrumbs}
                      hideBreadCrumbs={this.props.hideBreadCrumbs}
                      pageContext={
                        this.props?.children?.props?.searchState?.refinementList
                      }
                      shouldDefaultRegionalize={
                        this.props?.shouldDefaultRegionalize
                      }
                      facetLocation={this.props?.facetLocation}
                      isLuxury={this.props?.isLuxury}
                      isUnitedKingdomPage={this.isUnitedKingdomPage}
                      location={this.props?.location}
                      center={this.props?.center}
                      term={this.props?.term}
                      locationAllowList={this.props?.locationAllowList}
                      backgroundColor={this.props?.backgroundColor}
                    />
                  )}
                  {childrenWithProps}
                  <HydrationSplitter>
                    <Footer
                      shouldDefaultRegionalize={
                        this.props?.shouldDefaultRegionalize
                      }
                      isUnitedKingdomPage={this.isUnitedKingdomPage}
                      className={this.props.footerClassName}
                      location={this.props?.location}
                      term={this.props?.term}
                      departmentFooter={this.getDepartmentFooter()}
                    />
                  </HydrationSplitter>
                </React.Fragment>
              )}
              {this.props.data && (
                <React.Fragment>{this.props.children}</React.Fragment>
              )}
            </React.Fragment>
          </div>
        </ThemeProvider>
        {this.props.loadFurtherAiScript && (
          <script type="text/javascript">
            {(function () {
              if (typeof document === 'undefined') {
                return
              }

              if (window.location.hostname !== 'recovery.com') {
                return
              }

              var a = document.createElement('script')
              var b = document.getElementsByTagName('script')[0]
              a.type = 'text/javascript'
              a.src =
                ('https:' == document.location.protocol
                  ? 'https://'
                  : 'http://') + 'js.talkfurther.com/talkfurther_init.min.js'
              a.async = true
              b.parentNode.insertBefore(a, b)
            })()}
          </script>
        )}
      </HydrationSplitter>
    )
  }
}
